// extracted by mini-css-extract-plugin
module.exports = {"navBarTeam":"styles_navBarTeam__3FkFu","searchInput":"styles_searchInput__2sZgZ","time":"styles_time__2BFIi","timeButton":"styles_timeButton__2pn7v"};